import React from 'react';

const Copyright = () => {

    return (
        <p className="copyright">Copyright 2024 TheDaftlab All Rights Reserved.</p>
    );
};

export default Copyright;